import actionTypes from '../../shared/constants/actionTypes';

export function languageData(languageData) {
    return { type: actionTypes.LANGUAGEDATA, data: languageData };
}
